import React from 'react';
import VoiceToTextTextarea from '@components/VoiceToTextTextarea';
import getVoiceToTextBlockedMessages from './VoiceTranscribing/utils';
import { AboutMeTypes } from '../StepThreeTypes';

interface SupportedByProps {
  aboutMe: AboutMeTypes;
  setAboutMe: (aboutMe: AboutMeTypes) => void;
}

const SupportedBy: React.FC<SupportedByProps> = ({ aboutMe, setAboutMe }) => {
  return (
    <div className="govuk-form-group mt-10 govuk-bp:mt-14">
      <h1 className="govuk-label-wrapper">
        <label className="govuk-label govuk-label--l" htmlFor="supported-by">
          Supported to write this by
        </label>
      </h1>

      <div className="govuk-body">
        Where relevant, this is a record of name, relationship/role and contact
        details of the individual(s) who supported the person to write this
        section e.g. carer, family member, advocate, professional.
      </div>
      <details className="govuk-details">
        <summary className="govuk-details__summary">
          <span className="govuk-details__summary-text">
            Further information
          </span>
        </summary>
        <div className="govuk-details__text">
          <div className="govuk-body">
            This sub-section records the information about who supported the
            person to write the About Me. This could pick up an
            individual&apos;s details if they exist in a system being used to
            create an About Me.
          </div>
          <div className="govuk-body">
            Where someone does not have the capacity or capability to do their
            About Me themselves or with support, this should be used to explain
            how it was completed (e.g. from their experience of caring for the
            person supported by notes from their record etc). Note that getting
            the views of the person as much as possible should remain the aim.
          </div>
        </div>
      </details>

      <VoiceToTextTextarea
        id="supported-by"
        name="supportedBy"
        value={aboutMe.supportedBy || ''}
        rows={5}
        autoComplete="bio"
        placeholder="Type here or use voice to text..."
        recordBlockedErrors={getVoiceToTextBlockedMessages(aboutMe)}
        onChange={value => setAboutMe({ ...aboutMe, supportedBy: value })}
      />
    </div>
  );
};

export default SupportedBy;
